// extracted by mini-css-extract-plugin
export default {"Container":"ContactPage_Container__njy1Y","Content":"ContactPage_Content__OeHrm","BubbleContainer":"ContactPage_BubbleContainer__kyl+o","Image":"ContactPage_Image__-i6Ih"};